import { render, staticRenderFns } from "./DateSelectorSkeleton.vue?vue&type=template&id=3587aba1&scoped=true"
import script from "./DateSelectorSkeleton.vue?vue&type=script&lang=js"
export * from "./DateSelectorSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3587aba1",
  null
  
)

export default component.exports